const defaultTimeDepositAccountDetail = {
    currentBalance: 0,
    originalBalance: 0,
    interestPaidYtd: 0,
    accruedInterest: 0,
    term: '',
    interestRate: 0,
    issuedDate: '',
    maturityDate: '',
};

import { DashboardTimeDepositTransactionDetailModelDto } from '@treasury/api/channel';
import { formatUsdCurrency } from '@treasury/utils';
import { format } from 'date-fns';
import { DomainEntity } from '../../shared';

export class TimeDepositAccountDetail extends DomainEntity<DashboardTimeDepositTransactionDetailModelDto> {
    constructor(public source = defaultTimeDepositAccountDetail) {
        super(source);
    }

    public createDefault(): this {
        return new TimeDepositAccountDetail(defaultTimeDepositAccountDetail) as this;
    }

    public get currentBalance() {
        return formatUsdCurrency(this.source.currentBalance);
    }

    public get originalBalance() {
        return formatUsdCurrency(this.source.originalBalance);
    }

    public get interestPaidYtd() {
        return formatUsdCurrency(this.source.interestPaidYtd);
    }

    public get accruedInterest() {
        return formatUsdCurrency(this.source.accruedInterest);
    }

    public get term() {
        return `${this.source.term} days`;
    }

    public get interestRate() {
        return new Intl.NumberFormat('default', {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(this.source.interestRate);
    }

    public get issuedDate() {
        return format(this.source.issuedDate, 'MM/dd/yyyy');
    }

    public get maturityDate() {
        return format(this.source.maturityDate, 'MM/dd/yyyy');
    }
}
